module.exports = __webpack_public_path__ + "static/media/usa-flag.21403be5.svg";